<template>
  <span>
    <v-icon>{{ icon }}</v-icon>
  </span>
</template>

<script>
export default {
  name: "ColumnShortcut",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    icon() {
      return this.item.isShortcut ? "star" : "star_border";
    }
  },
  methods: {}
};
</script>
